<template>
    <div>
        <header class="g-hd f-bcf">
            <img class="back" @click="backward()" src="../../assets/jxwx/arr_02.png" alt=""> 科室主诊组医保均次占比
        </header>
        <div class="u-card cardBox" v-for="item in countData" :key="item.id" @click="toDepDetails(item)">
            <div class="hd">
                <div class="tt">
                    <img class="icon" src="../../assets/jxwx/report/icon_04.png" alt="">
                    <span>{{item.departMentName}}</span>
                </div>
                <img class="arr" src="../../assets/jxwx/arr_05.png" alt="">
            </div>
            <div class="bd">
                <div class="m-hos">
                    <header class="f-df">
                        <img src="../../assets/jxwx/report/point.png" alt=""> 门诊-城镇
                    </header>
                    <div class="progress">
                        <div class="progress_bar" :class="{'progress_bar2':item.townouthosprop <= 80,'progress_bar3':item.townouthosprop >= 100}" :style="{width: item.townouthosprop + '%'}">
                        </div>
                    </div>
                    <div class="entry">
                        <span class="ctt">当前医保均次占比</span>
                        <span class="mark nm">{{item.townouthosprop}}%</span>
                    </div>
                </div>
                <div class="m-hos">
                    <header class="f-df">
                        <img src="../../assets/jxwx/report/point.png" alt=""> 门诊-居民
                    </header>
                    <div class="progress">
                        <div class="progress_bar" :class="{'progress_bar2':item.resouthosprop <= 80,'progress_bar3':item.resouthosprop >= 100}" :style="{width: item.resouthosprop + '%'}">
                        </div>
                    </div>
                    <div class="entry">
                        <span class="ctt">当前医保均次占比</span>
                        <span class="mark nm">{{item.resouthosprop}}%</span>
                    </div>
                </div>
                <div class="m-hos">
                    <header class="f-df">
                        <img src="../../assets/jxwx/report/point.png" alt=""> 住院-城镇
                    </header>
                    <div class="progress">
                        <div class="progress_bar" :class="{'progress_bar2':item.towninhosprop <= 80,'progress_bar3':item.towninhosprop >= 100}" :style="{width: item.towninhosprop + '%'}">
                        </div>
                    </div>
                    <div class="entry">
                        <span class="ctt">当前医保均次占比</span>
                        <span class="mark nm">{{item.towninhosprop}}%</span>
                    </div>
                </div>
                <div class="m-hos">
                    <header class="f-df">
                        <img src="../../assets/jxwx/report/point.png" alt=""> 住院-居民
                    </header>
                    <div class="progress">
                        <div class="progress_bar" :class="{'progress_bar2':item.resinhosprop <= 80,'progress_bar3':item.resinhosprop >= 100}" :style="{width: item.resinhosprop + '%'}">
                        </div>
                    </div>
                    <div class="entry">
                        <span class="ctt">当前医保均次占比</span>
                        <span class="mark nm">{{item.resinhosprop}}%</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from "@/axios/api";
export default {
    data() {
        return {
            time:this.$route.query.time,
            countData:[]
        };
    },
    mounted() {
        this.getDailyCountData()
    },
    methods: {
        backward() {
            this.$router.backward();
            // alert(this.$route.params.isBack)
        },
        
        getDailyCountData() {
            let params = {
                date: this.time,
                depId:"",
                deptMentId:""
            };
            api.getDailyCountData(params).then(res => {
                this.countData = res;
            });
        },

        toDepDetails(item) {
            this.$router.replace({
                path: "/jxwx/depDetails",
                query: {
                    data:item,
                    time: this.time
                }
            });
        },
    }
};
</script>

<style lang="less" scoped>
.g-hd {
    display: flex;
    align-items: center;
    height: 13.3vw;
    padding: 0 0 0 3.3vw;
    .back {
        width: 2vw;
        font-size: 16px;
        margin-right: 2.6vw;
    }
    .tt {
        margin-left: 4vw;
    }
}
.u-card {
    margin: 2.6vw 4vw;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 1px 4px 0px rgba(225, 225, 225, 0.42);
    border-radius: 6px;
}
.cardBox {
    .hd {
        display: flex;
        font-size: 13px;
        justify-content: space-between;
        align-items: center;
        height: 12vw;
        padding: 0 4vw;
        border-bottom: 1px solid #dedede;
        .icon {
            width: 4vw;
        }
        .tt {
            display: flex;
            align-items: center;
            img {
                margin-right: 1.6vw;
            }
        }
        .arr {
            width: 1.3vw;
        }
    }
    .bd {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        padding: 2vw;
        .m-hos {
            width: 50%;
            padding: 0 2vw;
            box-sizing: border-box;
            .f-df {
                display: flex;
                align-items: center;
            }
        }
        // .m-hos2 {
        //     width: 42vw;
        //     padding: 0 ;
        // }
        .m-hos header {
            margin-bottom: 3.4667vw;
            font-size: 14px;
            color: #4c4c4c;
        }
        .m-hos header img {
            width: 1.3333vw;
            margin-right: 1.3333vw;
        }
        .m-hos .progress {
            width: 100%;
            height: 2.1333vw;
            margin-bottom: 2.6667vw;
            border-radius: 1.0667vw;
            background-color: #efefef;
            overflow: hidden;
            .progress_bar {
                height: 100%;
                background-color: #fed100;
            }
            .progress_bar2 {
                height: 100%;
                background-color: #91C619;
            }
            .progress_bar3 {
                height: 100%;
                background-color: #F66969;
            }
        }

        .m-hos .entry {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 3.2vw;
            font-size: 12px;
        }
        .m-hos > .entry > .ctt {
            color: #8f8f8f;
        }
        .m-hos > .entry > .nm {
            font-size: 13px;
            color: #282828;
        }
        .m-hos > .entry > .mark {
            color: #f66969;
            background: #fff;
        }
        .m-hos > .entry > .mark2 {
            color: #91c619;
        }
    }
}
</style>





// WEBPACK FOOTER //
// src/jxwx/components/allDepartment.vue